export default __webpack_public_path__ + "static/media/noimage.d7c79dbd.jpg";